import React from 'react';
import { ResetPassword as SharedResetPassword } from '@gastrosoft/shared/auth';
import { useBranding } from '../contexts/BrandingContext';
import { authClient } from './authClient';

export default function ResetPassword() {
  const { logo, appName } = useBranding();
  return <SharedResetPassword appTitle={appName} logo={logo} authClient={authClient} />;
}
